import React from 'react';
import { render } from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import { configureStore, AppState } from 'state/store';
import ThemeWrapper from 'styles/ThemeProvider';
import { Store, AnyAction } from 'redux';
import TokenManager from 'Api/TokenManager';
import { USER_LOGOUT } from 'state/user/UserActionTypes';
import AdminViewModeProvider from 'state/AdminViewModeContext';

(async () => {
   const token: string | null = await TokenManager.getAccessToken();

   const store: Store<AppState, AnyAction> = configureStore({
      currentUser: {
         isAuthenticated: !!token,
      },
      requestedPathname: window.location.pathname.concat(window.location.search),
   });

   TokenManager.setAccessTokenExpirationHandler(async () => {
      await store.dispatch({ type: USER_LOGOUT });
      TokenManager.clearTokens();
   });
   render(
      <ThemeWrapper>
         <AdminViewModeProvider>
            <Provider store={store}>
               <App />
            </Provider>
         </AdminViewModeProvider>
      </ThemeWrapper>,
      document.getElementById('root')
   );

   serviceWorker.unregister();
})();
